import type { FunctionComponent, HTMLProps, ReactNode } from 'react'
import { createElement } from 'react'

import classnames from 'classnames'

import styles from './Grid.module.scss'

/**
 * Basic Grid system for layout.
 */
export const Grid: FunctionComponent<Props> = ({
  children,
  tag = 'section',
  includeGaps = true,
  includeGutters = true,
  className,
  ...rest
}) => {
  const props = {
    className: classnames(
      styles.grid,
      {
        [styles.gridGaps]: includeGaps,
        [styles.gridGutter]: includeGutters,
      },
      className
    ),
    'data-testid': `grid`,
    ...rest,
  }

  return createElement(tag, props, children)
}

///////// IMPLEMENTATION /////////

type Props = {
  tag?: 'section' | 'div'
  includeGaps?: boolean
  includeGutters?: boolean
  className?: string
  children?: ReactNode
} & HTMLProps<HTMLElement>
